import { create } from 'zustand'

import { apiGetCurrentUser } from '@/features/auth/api/api-get-current-user'
import type { CurrentUser } from '@/features/auth/types/user'

type CurrentUserStatus = 'idle' | 'loading' | 'ready' | 'error'

type CurrentUserStore = {
  user: CurrentUser | null
  status: CurrentUserStatus
  error: string | null
  load: () => Promise<void>
  clear: () => void
}

const initialState = {
  user: null,
  status: 'idle' as const,
  error: null,
}

export const useCurrentUserStore = create<CurrentUserStore>((set, get) => ({
  ...initialState,
  load: async () => {
    if (get().status === 'loading' || get().status === 'ready') {
      return
    }

    set({ status: 'loading', error: null })

    try {
      const user = await apiGetCurrentUser()
      set({ user, status: 'ready', error: null })
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : 'Unable to load your account. Please try again.'

      set({ user: null, status: 'error', error: message })
    }
  },
  clear: () => set(initialState),
}))

export const useCurrentUser = () => useCurrentUserStore((state) => state.user)
